import { combineReducers } from 'redux'

import { reducer as filter } from 'store/filter'

export const combinedReducer = combineReducers({
	filter,
})
